import React, { useEffect } from "react";
import Greeting from "../../greeting/Greeting";
import Skills from "../../skills/Skills";
import StackProgress from "../../skillProgress/skillProgress";
import WorkExperience from "../../workExperience/WorkExperience";
import StartupProject from "../../StartupProjects/StartupProject";
import Achievement from "../../achievement/Achievement";
import Blogs from "../../blogs/Blogs";
import Talks from "../../talks/Talks";
import Podcast from "../../podcast/Podcast";
import Education from "../../education/Education";
import Profile from "../../profile/Profile";
import "./Home.scss";
import Header from "../../../components/header/Header";

const Home = () => {
  useEffect(() => {}, []);

  return (
    <div>
      <>
        <Header showNavigation={true} />
        <Greeting />
        <Skills />
        <StackProgress />
        <Education />
        <WorkExperience />
        {/* <Projects /> */}
        <StartupProject />
        <Achievement />
        <Blogs />
        <Talks />
        <Podcast />
        <Profile />
      </>
    </div>
  );
};

export default Home;
